module.exports = __webpack_public_path__ + "img/White-Logo.d3d5ec7e.svg";